import { useMediaQuery, useTheme } from "@mui/material";

export function useIsMobile() {
  return useMediaQuery(useTheme().breakpoints.down("sm"));
}
